import PageContainer from "../../../../../components/PageContainer/PageContainer";
import {
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import { restUseCase } from "../../../../../usecases/rest";
import FormUtils from "../../../../../utils/classUtils/FormUtils";
import withRouter from "../../../../../utils/withRouter";
import ProfileFormPresenter from "./ProfileFormPresenter";
import CreateUserForm from "./components/CreateUserForm";

class ProfileFormPage extends FormUtils {
  constructor(props) {
    super(props);
    this.state = { object: {}, modalState: false };
    this.presenter = new ProfileFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      restUseCase(),
    );
  }

  getCollectionName() {
    return "users";
  }

  getAcl() {
    const user = this.getCurrentUser();
    return {
      write: ["role:affiliate", user.id, "role:admin"],
    };
  }

  render() {
    const { fields, sections } = this.getSchema(this.getCollectionName());
    const { object } = this.state;

    return (
      <PageContainer title="Create User Information">
        <form onSubmit={this.onSubmitForm.bind(this)}>
          <CreateUserForm
            schema={this.transformFieldsToSections({ fields, sections })}
            userInfo={
              this.isEditing() ? this.formatObjectRoles(object) : object
            }
            fieldsToExlude={[
              ...this.fieldsToExclude,
              "status",
              "registrationStatus",
              "startDate",
              "credit",
              "approvedBy",
              "is_Delete",
              "last_login_at",
              "last_logout_at",
            ]}
            isEditing={this.isEditing()}
            onChange={this.onChange.bind(this)}
            navigateBack={this.navigateBack.bind(this)}
          />
        </form>
      </PageContainer>
    );
  }
}

export default withRouter(ProfileFormPage);
